
const quick_authorize_url = [
  "/movie/index"
]

export function $is_quick_authorize_redirect() {
  for (var i = 0; i < quick_authorize_url.length; i++) {
    if (quick_authorize_url[i] == location.pathname) {
      return true
    }
  }

  return false
}